<template>
  <div id="__surequote">
    <div class="__surequote__intro">
      <h2>Get a Boiler Installation Quote</h2>
      <p>To get an idea of how much it will cost to install a new boiler, just answer a few quick questions...</p>
      <p class="small">It won't take longer than 5 minutes!</p>
      <custom-button @click.native="startWizard" type="success">Start Now</custom-button>
    </div>
    <div class="__surequote-modal__container" v-if="showWizard">
      <div class="__surequote-modal">
        <div class="__loader" :class="{'__loader--active': isLoading}"></div>
        <div class="__surequote_header" :style="{backgroundColor: PrimaryColour}">
          <h1>SUREQUOTE</h1>
          <custom-button size="sm" class="fr" @click.native="closeWizard">Close</custom-button>
        </div>
        <surequote-debug v-if="isDebug"></surequote-debug>

        <div class="surequote__primecontent">
          <router-view/>
        </div>
        
        <router-view name="navigation"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_SETTINGS, SUBMIT_QUESTIONS, RESTART_QUESTIONS, RESET_QUOTE } from '@/store/actions.type.js';
import Debug from '@/components/Debug.vue';

export default {
  name: 'app',
  data() {
    return {
      apiKey: '',
      showWizard: false
    }
  },
  beforeMount(){
    this.apiKey = document.getElementById('__surequote_data').dataset.apikey;
    //console.log(apikey);
  },
  computed: {
    ...mapGetters(["isLoading", "PrimaryColour", "isDebug"])
  },
  mounted(){
    //this.$store.dispatch(FETCH_SETTINGS, this.apiKey);
  },
  created() {
    this.$router.push('/')
  },
  methods: {
    async startWizard() {
      await this.$store.dispatch(FETCH_SETTINGS, this.apiKey);
      this.showWizard = !this.showWizard
    },
    closeWizard() {
      this.showWizard = false;
      this.$store.dispatch(RESET_QUOTE)
      this.$store.dispatch(RESTART_QUESTIONS)
      this.$router.push('/');
    }
  },
  components: {
    'surequote-debug': Debug
  }
}
</script>


<style lang="scss">
#__surequote {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
